var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProven(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.949219,
    width: 44.4138,
    height: 44.4138,
    rx: 7.4023,
    fill: "#212224"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6179 30.6249C25.8422 31.1445 23.8082 32.2057 25.047 33.5334C25.6522 34.182 26.3263 34.6459 27.1736 34.6459H29.5913H32.0089C32.8563 34.6459 33.5304 34.182 34.1356 33.5334C35.3744 32.2057 33.3404 31.1445 32.5646 30.6249C30.7455 29.4063 28.4371 29.4063 26.6179 30.6249Z",
    stroke: "white",
    strokeWidth: 1.85063
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.06 24.1589C32.06 25.5217 30.9553 26.6264 29.5925 26.6264C28.2297 26.6264 27.125 25.5217 27.125 24.1589C27.125 22.7961 28.2297 21.6914 29.5925 21.6914C30.9553 21.6914 32.06 22.7961 32.06 24.1589Z",
    stroke: "white",
    strokeWidth: 1.85063
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 16.1388H25.8875M19.7188 12.4375H29.5887",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0203 20.457V26.009C16.0203 27.1721 16.0203 27.7537 15.659 28.1151C15.2976 28.4765 14.716 28.4765 13.5528 28.4765H12.3191C11.1559 28.4765 10.5743 28.4765 10.2129 28.1151C9.85156 27.7537 9.85156 27.1721 9.85156 26.009V22.9246C9.85156 21.7614 9.85156 21.1798 10.2129 20.8184C10.5743 20.457 11.1559 20.457 12.3191 20.457H16.0203ZM16.0203 20.457H22.1891",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4037 14.905C15.4037 16.2678 14.299 17.3725 12.9362 17.3725C11.5735 17.3725 10.4688 16.2678 10.4688 14.905C10.4688 13.5422 11.5735 12.4375 12.9362 12.4375C14.299 12.4375 15.4037 13.5422 15.4037 14.905Z",
    stroke: "white",
    strokeWidth: 1.85063
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProven);
export default __webpack_public_path__ + "static/media/proven.e10303ee253d24eada6c13568d847941.svg";
export { ForwardRef as ReactComponent };